<template>
  <v-card class="invite-friend-card nc-form">
    <v-card-title>
      <p>Ти можеш запросити когось стати одним з <i>Наших!</i></p>
      <p>Май на увазі що людина, яку ти запросиш, буде мати доступ до всього контенту, зможе писати коментарі, буде отриувати повідомлення про нові пости тощо. Тож надсилай запрошення лише перевіреним людям :)</p>
      <p>Якщо ти хочеш просто показати комусь якийсь конкретний пост можливо варто скористатися кнопкою<v-icon>share</v-icon> на сторінці цього поста.</p>
    </v-card-title>
    <v-card-text>
      <div class="email-wrapper">
        <label>Електронна пошта для запрошення</label>
        <input
          v-model="email"
        ></input>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        flat
        @click="cancel"
        :disabled="saving"
      >
        Скасувати
      </v-btn>
      <v-btn
        outline
        @click="save"
        :disabled="saving || !email"
      >
        <v-progress-circular
          v-if="saving"
          :size="24"
          color="grey"
          indeterminate
        ></v-progress-circular>
        <span v-else>Запросити</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import moment from 'moment';

import { randomString } from '@/services/random';
import { createInvite } from '@/firebase/repositories/invites';

export default {
  name: 'InviteFriendCard',
  data() {
    return {
      key: randomString(40),
      email: '',

      saving: false,
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    user() {
      return this.$store.state.user;
    },
    urlPrefix() {
      return `${location.origin}/login/invite/`;
    },
    url() {
      return `${this.urlPrefix}${this.key}`;
    },
  },
  mounted() {
    this.key = randomString(40);
  },
  methods: {
    cancel() {
      this.$emit('canceled');
    },
    save() {
      const invite = {
        title: `${this.user.name} запрошує ${this.email}`,
        email: {
          email: this.email,
          subject: `Запрошення від ${this.user.name}`,
          text: `${this.user.name} запрошує вас на сайт Корпорації «Наші». Для входу перейдіть за посиланням:

${this.url}`,
        },
        roles: {
          member: true,
        },
        author: {
          uid: this.auth.uid,
          name: this.auth.displayName,
          email: this.auth.email,
        },
        created: moment().valueOf(),
      };

      this.saving = true;
      createInvite(this.key, invite)
        .then(() => {
          this.saving = false;
          this.$emit('created');
        });
    },
  },
};

</script>

<style scoped>

.invite-friend-card {
  box-shadow: none;
}

.card__actions {
  padding: 16px;
}

.invite-friend-card .btn {
  margin-left: 5px;
}


</style>



// WEBPACK FOOTER //
// src/containers/InviteFriendCard.vue